export default __webpack_public_path__ + "static/media/checkmark-circle.01a419bb.svg";